import {
  BUFFERED_AMOUNT_LIMIT_BYTES,
  BUFFERED_AMOUNT_LOW_BYTES,
  DATA_CHANNEL_LABEL,
} from "../localTransfer.constants";

const CHANNEL_CLOSED_ERROR_MESSAGE =
  "Data channel closed before the transfer completed.";

const assertChannelOpen = (channel) => {
  if (channel.readyState === "open") return;

  throw new Error(CHANNEL_CLOSED_ERROR_MESSAGE);
};

export const createLocalPeerConnection = () =>
  new RTCPeerConnection({ iceServers: [] });

export const createTransferDataChannel = (peerConnection) => {
  const channel = peerConnection.createDataChannel(DATA_CHANNEL_LABEL, {
    ordered: true,
  });
  channel.binaryType = "arraybuffer";
  channel.bufferedAmountLowThreshold = BUFFERED_AMOUNT_LOW_BYTES;
  return channel;
};

export const waitForIceGatheringComplete = (peerConnection) => {
  if (peerConnection.iceGatheringState === "complete") {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const handleStateChange = () => {
      if (peerConnection.iceGatheringState !== "complete") return;

      peerConnection.removeEventListener("icegatheringstatechange", handleStateChange);
      resolve();
    };

    peerConnection.addEventListener("icegatheringstatechange", handleStateChange);
  });
};

export const closePeerConnection = (peerConnection) => {
  if (!peerConnection) return;

  peerConnection.getSenders().forEach((sender) => sender.track?.stop());
  peerConnection.close();
};

const waitForBufferedAmountLow = (channel) =>
  new Promise((resolve) => {
    channel.onbufferedamountlow = () => {
      channel.onbufferedamountlow = null;
      resolve();
    };
  });

export const waitForChannelBuffer = async (channel) => {
  if (channel.bufferedAmount < BUFFERED_AMOUNT_LIMIT_BYTES) return;

  await waitForBufferedAmountLow(channel);
};

export const sendChannelMessage = async ({ channel, message }) => {
  assertChannelOpen(channel);
  channel.send(message);
  await waitForChannelBuffer(channel);
};
